import { ArrowRight } from "lucide-react";
import { PETITION_URL } from "../lib/constants";
import SocialShare from "./SocialShare";

export const PetitionCTA = ({ variant = "dark" }) => {
    const isDark = variant === "dark";
    return (
        <section
            data-testid="petition-cta"
            className={`relative overflow-hidden ${isDark ? "bg-navy-900 text-editorial" : "bg-editorial-muted text-navy-900"}`}
        >
            <div className="absolute inset-0 bg-noise opacity-30 pointer-events-none" />
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 md:py-28 relative grid lg:grid-cols-12 gap-10 items-center">
                <div className="lg:col-span-7">
                    <p className={`overline mb-6 ${isDark ? "text-gold" : "text-coral"}`}>The Petition</p>
                    <h2 className={`font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight mb-6 ${isDark ? "text-editorial" : "text-navy-900"}`}>
                        Help require AEDs and CPR training in hotels.
                    </h2>
                    <p className={`text-lg md:text-xl leading-relaxed max-w-2xl mb-10 ${isDark ? "text-editorial/75" : "text-navy-800/80"}`}>
                        Add your name to support legislation that ensures every guest, family, and traveler has access to life-saving equipment and trained staff in moments that matter most.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                        <a
                            href={PETITION_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="petition-sign-btn"
                            className="group inline-flex items-center gap-3 px-8 py-4 bg-coral hover:bg-coral-dark text-white font-semibold transition-all duration-300"
                        >
                            Sign the Petition
                            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                        </a>
                        <SocialShare url={PETITION_URL} testidPrefix="petition-share" />
                    </div>
                </div>

                <div className="lg:col-span-5">
                    <div className={`border ${isDark ? "border-white/10 bg-white/5" : "border-navy-900/10 bg-white"} p-8 lg:p-10`}>
                        <div className="overline mb-4">A Reminder</div>
                        <p className={`font-serif text-2xl md:text-3xl italic leading-snug ${isDark ? "text-editorial" : "text-navy-900"}`}>
                            "No one should ever have to face a cardiac emergency alone without access to trained staff or life-saving equipment."
                        </p>
                        <p className={`mt-6 text-sm uppercase tracking-[0.2em] ${isDark ? "text-gold" : "text-coral"}`}>
                            — Ciera Gingery, Founder
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PetitionCTA;
